import { useQuery } from "@tanstack/react-query";
import { fetchPostpaidTerms } from "@/api/campaigns";

/**
 * Whether the caller's organisation may launch postpaid, and on what terms. A preview for Step 4 —
 * launch re-reads and re-checks all of it — so it is fetched once and kept fresh for a minute.
 */
export function usePostpaidTerms(enabled = true) {
  return useQuery({
    queryKey: ["postpaid-terms"],
    queryFn: fetchPostpaidTerms,
    enabled,
    staleTime: 60_000,
  });
}
